import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const textTriggerDefaultVariants = {
  "color": "neutral-2"
}
const textTriggerCompoundVariants = []

const textTriggerSlotNames = [
  [
    "root",
    "textTrigger__root"
  ],
  [
    "label",
    "textTrigger__label"
  ]
]
const textTriggerSlotFns = /* @__PURE__ */ textTriggerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, textTriggerDefaultVariants, getSlotCompoundVariant(textTriggerCompoundVariants, slotName))])

const textTriggerFn = memo((props = {}) => {
  return Object.fromEntries(textTriggerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const textTriggerVariantKeys = [
  "color"
]
const getVariantProps = (variants) => ({ ...textTriggerDefaultVariants, ...compact(variants) })

export const textTrigger = /* @__PURE__ */ Object.assign(textTriggerFn, {
  __recipe__: false,
  __name__: 'textTrigger',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: textTriggerVariantKeys,
  variantMap: {
  "color": [
    "neutral-4",
    "neutral-3",
    "neutral-2",
    "neutral-1",
    "positive",
    "negative",
    "warning"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, textTriggerVariantKeys)
  },
  getVariantProps
})